export default {
  pageTitle: '配管製作',
  metaDescription: 'TEFはチタン、デュプレックス、合金材料によるプレハブ配管スプールを製作し、石油化学・製薬プラントへの効率的な設置を実現します。',
  sidebar: {
    title: '製作リスト',
    vessel: 'ベッセル製作',
    heatExchanger: '熱交換器製作',
    piping: '配管製作',
    tower: '塔槽製作',
    muffle: 'マッフル製作',
    radiantTube: 'ラジアントチューブ製作',
    otherEquipment: 'その他設備製作',
  },
  fabricationOf: '製作',
  product: {
    name: '配管',
    desc: '以下は、当社の配管製作における各種材質・タイプ・仕様の実績カタログです。',
  },
};
